export function ProviderBadge({ provider }: { provider: string }) {
  const blue = provider === 'sigil';
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 font-mono text-[10px] font-medium uppercase tracking-eyebrow ${
        blue ? 'bg-bit2me-tint text-bit2me' : 'bg-surface-soft text-ink-secondary'
      }`}
    >
      {provider}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const ok = status === 'active';
  return (
    <span
      className={`inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-eyebrow ${
        ok ? 'text-ok' : 'text-ink-tertiary'
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${ok ? 'bg-ok' : 'bg-ink-muted'}`} />
      {status}
    </span>
  );
}

export function CurveBadge({ curve }: { curve: string }) {
  return (
    <span className="inline-flex items-center rounded bg-surface-soft px-1.5 py-0.5 font-mono text-[10px] font-medium text-ink-secondary">
      {curve}
    </span>
  );
}
